<template>
  <div class="rating-footer d-flex align-center">
    <v-btn
      icon
      size="x-small"
      variant="text"
      :color="rating === 1 ? 'success' : undefined"
      :title="t('chat.goodResponse')"
      @click="rate(1)"
    >
      <v-icon size="14">{{ rating === 1 ? 'mdi-thumb-up' : 'mdi-thumb-up-outline' }}</v-icon>
    </v-btn>
    <v-btn
      icon
      size="x-small"
      variant="text"
      :color="rating === -1 ? 'error' : undefined"
      :title="t('chat.badResponse')"
      @click="onThumbsDown"
    >
      <v-icon size="14">{{ rating === -1 ? 'mdi-thumb-down' : 'mdi-thumb-down-outline' }}</v-icon>
    </v-btn>

    <v-dialog v-model="commentDialog" max-width="400">
      <v-card>
        <v-card-title class="text-body-1">{{ t('chat.whatWentWrong') }}</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="comment"
            :placeholder="t('chat.optionalFeedback')"
            rows="3"
            density="compact"
            auto-grow
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="commentDialog = false">{{ t('common.cancel') }}</v-btn>
          <v-btn color="primary" variant="flat" @click="submitThumbsDown">{{ t('common.submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { useI18n } from '../../composables/useI18n.js'
const { t } = useI18n()
import { ref } from 'vue'
import { useSessionsStore } from '../../stores/sessions.js'
import { rateSession } from '../../api/sessions.js'

const sessionsStore = useSessionsStore()

// Local per-turn state on a session-level endpoint: the footer only renders
// under the latest completed turn, so re-rating overwrites the session rating.
const rating = ref(0)
const commentDialog = ref(false)
const comment = ref('')

async function rate(value) {
  const prev = rating.value
  rating.value = prev === value ? 0 : value
  const sessionId = sessionsStore.activeSessionId
  if (!sessionId) return
  try {
    await rateSession(sessionId, rating.value, '')
  } catch {
    rating.value = prev
  }
}

function onThumbsDown() {
  if (rating.value === -1) {
    rate(-1)
  } else {
    comment.value = ''
    commentDialog.value = true
  }
}

async function submitThumbsDown() {
  commentDialog.value = false
  const sessionId = sessionsStore.activeSessionId
  if (!sessionId) return
  const prev = rating.value
  rating.value = -1
  try {
    await rateSession(sessionId, -1, comment.value)
  } catch {
    rating.value = prev
  }
}
</script>

<style scoped>
/* Tuck under the preceding bubble's mb-3 (12px), leaving a 4px gap. */
.rating-footer {
  margin-top: -8px;
  margin-bottom: 12px;
  padding-left: 4px;
}
</style>
